import { render, staticRenderFns } from "./TeamCreate.vue?vue&type=template&id=a899623a&scoped=true"
import script from "./TeamCreate.vue?vue&type=script&lang=js"
export * from "./TeamCreate.vue?vue&type=script&lang=js"
import style0 from "./TeamCreate.vue?vue&type=style&index=0&id=a899623a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a899623a",
  null
  
)

export default component.exports